module.exports = __webpack_public_path__ + "img/42.8cecaf44.png";